export const cacheControl = (res, seconds = 20) => {
  res.setHeader(
    'Cache-Control',
    `s-maxage=${seconds}`,
    'stale-while-revalidate'
  );
};
